const SESSION_KEY_TOKEN = 'token';
const SESSION_KEY_USER = 'user';

export { SESSION_KEY_TOKEN, SESSION_KEY_USER };
export default {
  SESSION_KEY_TOKEN,
  SESSION_KEY_USER
};
